import React, { useEffect } from 'react'
import { Select } from '@st-operations/uikit/src/v2'

export const SCALES = {
  NORMAL: 'normal',
  LOGARITHMIC: 'logarithmic',
}

export const SCALE_LABELS = {
  [SCALES.NORMAL]: 'Normal',
  [SCALES.LOGARITHMIC]: 'Logarithmic',
}

const ChartScaleSelect = ({
  label = 'Chart Scale',
  chartScale,
  chartScaleOptions = [
    { label: SCALE_LABELS[SCALES.NORMAL], value: SCALES.NORMAL },
    { label: SCALE_LABELS[SCALES.LOGARITHMIC], value: SCALES.LOGARITHMIC },
  ],
  onChartScaleChange = () => null,
}) => {
  useEffect(() => {
    if (chartScaleOptions.findIndex((opt) => opt.value === chartScale) === -1) {
      onChartScaleChange(chartScaleOptions[0].value)
    }
  }, [chartScaleOptions])

  return (
    <Select
      label={label}
      options={chartScaleOptions}
      value={chartScale}
      onChange={({ value }) => onChartScaleChange(value)}
      useReactSelect
    />
  )
}

export default ChartScaleSelect
